import { useMemo } from 'react'

import { DashboardCustomListRestEndpointService } from '@api'
import { useUnit } from 'effector-react'
import { useInfiniteQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'

export function useGetCustomListFans(listId: number, search: string) {
  const creatorId = useUnit($creatorId)
  const {
    data,
    isFetching,
    isLoading,
    error,
    isSuccess,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ['creator', creatorId, 'custom', listId, 'fans', search],
    queryFn: ({ pageParam = 0 }) =>
      DashboardCustomListRestEndpointService.dashboardGetCustomListFans({
        creatorId: creatorId!,
        listId,
        page: pageParam,
        fanName: search,
      }),
    getNextPageParam: (lastPage) => {
      if (
        lastPage.last ||
        lastPage.number === undefined ||
        lastPage.totalPages === undefined ||
        lastPage.number === lastPage.totalPages
      ) {
        return undefined
      }

      if (lastPage.number < lastPage.totalPages) {
        return lastPage.number + 1
      }

      return undefined
    },
    staleTime: 2 * 60 * 1000,
    enabled: !!creatorId && !!listId,
  })

  const fans = useMemo(
    () => data?.pages.flatMap((page) => page.content ?? []) ?? [],
    [data?.pages],
  )

  return {
    fans,
    isFetching,
    isLoading,
    error,
    isSuccess,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  }
}
